import { render } from "./bank.vue?vue&type=template&id=24a9e396"
import script from "./bank.vue?vue&type=script&lang=js"
export * from "./bank.vue?vue&type=script&lang=js"

import "./bank.vue?vue&type=style&index=0&id=24a9e396&lang=css"

import exportComponent from "/Users/newuser/Desktop/Development/Node/spider-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__